import { render, staticRenderFns } from "./GroupPermission.vue?vue&type=template&id=af1f9b58&scoped=true&"
import script from "./GroupPermission.vue?vue&type=script&lang=js&"
export * from "./GroupPermission.vue?vue&type=script&lang=js&"
import style0 from "./GroupPermission.vue?vue&type=style&index=0&id=af1f9b58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af1f9b58",
  null
  
)

export default component.exports